<template>
  <v-container>
    <v-row class="ma-0" no-gutters>
      <v-col>
        <!-- Banner -->
        <StaticBannerWithCurvedCard />

        <!-- Categories moved up for small screens -->
        <v-row v-if="breakpointSmAndDown" class="ma-0">
          <v-col cols="12">
            <AllCategories />
            <!-- <AllActivities /> -->
            <ActivityCalendar />
            <TrendingItems />
          </v-col>
        </v-row>

        <!-- Benefits -->
        <Benefits v-if="!breakpointSmAndDown" />

        <BlogEvents v-if="!breakpointSmAndDown" class="ma-0 mb-8 px-6" />

        <!-- Promotions -->
        <Promotions :loading="loadingPromotions" :promotions="promotions" />

        <BannerTextBlock />

        <v-row id="homePageBody" class="ma-0" dense>
          <!-- left sidebar -->
          <v-col
            id="leftSideBar"
            cols="2"
            class="sidebar hidden-sm-and-down pt-3 pt-md-7"
          >
            <!-- E.g.: Trending, download app -->
            <HomepageContainer :structure="homepageStructure.leftSide" />
          </v-col>

          <!-- main middle content -->
          <v-col
            cols="12"
            md="8"
            class="pt-0 px-3"
            id="middleSectionOfHomepage"
          >
            <HomepageContainer :structure="middleStructure" />
          </v-col>

          <!-- right sidebar -->
          <v-col
            id="rightSideBar"
            cols="2"
            class="sidebar hidden-sm-and-down pt-3 pt-md-7"
          >
            <HomepageContainer :structure="homepageStructure.rightSide" />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import homePageMixin from '@/mixins/homePage';
import HomepageStructure from '@/objects/HomepageStructure';
import Promotions from '@/components/homepage/Promotions';
import BlogEvents from '@/components/homepage/BlogEvents';
import Benefits from '@/components/homepage/Benefits';
import StaticBannerWithCurvedCard from '@/components/homepage/StaticBannerWithCurvedCard';
import HomepageContainer from '@/components/homepage/HomepageContainer';
import AllCategories from '@/components/homepage/AllCategories.vue';
import AllActivities from '@/components/homepage/AllActivities.vue';
import ActivityCalendar from '@/components/homepage/ActivityCalendar.vue';
import TrendingItems from '@/components/homepage/TrendingItems.vue';
import BannerTextBlock from '@/components/homepage/BannerTextBlock.vue';

export default {
  name: 'ClassicView',
  mixins: [homePageMixin],
  components: {
    StaticBannerWithCurvedCard,
    HomepageContainer,
    Promotions,
    BlogEvents,
    Benefits,
    AllCategories,
    AllActivities,
    ActivityCalendar,
    TrendingItems,
    BannerTextBlock,
  },
  created() {
    this.setHomepageStructure();
  },
  updated() {
    this.updateSideBarPosition();
  },
  data() {
    return {
      homepageStructure: {},
    };
  },
  computed: {
    userName() {
      return this.$store.getters['auth/userName'];
    },
    frontEndType() {
      return this.$store.getters.getFrontEndType;
    },
    middleStructure() {
      return this.$vuetify.breakpoint.smAndDown
        ? this.homepageStructure.middleSectionMobile
        : this.homepageStructure.middleSectionWeb;
    },
  },
  watch: {
    userName() {
      this.setHomepageStructure();
    },
    frontEndType() {
      this.setHomepageStructure();
    },
  },
  methods: {
    setHomepageStructure() {
      this.homepageStructure = new HomepageStructure(
        this.$store.getters.getFrontEndType,
        this.productFocused
      );
    },
    updateSideBarPosition() {
      // Move sibe bars down to the same level of categories / activities
      let orderEl = null;
      if (this.productFocused) {
        orderEl = document.querySelector('#allCategories');
      }
      // else {
      //   orderEl = document.querySelector('#allActivities');
      // }

      if (orderEl == null) {
        return;
      }

      const homePageBody = document.querySelector('#homePageBody');

      if (homePageBody == null) {
        return;
      }

      const sideBarOffset = orderEl.offsetTop - homePageBody.offsetTop;

      const leftSideBar = document.querySelector('#leftSideBar');
      const rightSideBar = document.querySelector('#rightSideBar');

      if (leftSideBar != null) {
        leftSideBar.style.marginTop = `${sideBarOffset}px`;
      }

      if (rightSideBar != null) {
        rightSideBar.style.marginTop = `${sideBarOffset}px`;
      }
    },
  },
};
</script>
